import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useState, useMemo } from 'react';
import { useFrame } from '@react-three/fiber';
import { Html } from '@react-three/drei';
import * as THREE from 'three';
export const SlotZone = ({ position, rotation, width, height, id, color = '#73c62f', onSelect, onOpen, popupContent, active = true, }) => {
    const meshRef = useRef(null);
    const [hovered, setHovered] = useState(false);
    const [open, setOpen] = useState(false);
    useFrame(({ clock }) => {
        if (!meshRef.current)
            return;
        const mat = meshRef.current.material;
        if (hovered) {
            mat.opacity = 0.15 + Math.sin(clock.getElapsedTime() * 4) * 0.08;
        }
        else {
            mat.opacity = THREE.MathUtils.lerp(mat.opacity, 0.05, 0.08);
        }
    });
    const colorObj = useMemo(() => new THREE.Color(color), [color]);
    const edgesGeometry = useMemo(() => {
        const geo = new THREE.PlaneGeometry(width, height);
        return new THREE.EdgesGeometry(geo);
    }, [width, height]);
    const handleClick = (e) => {
        e.stopPropagation();
        if (!active)
            return;
        setOpen(prev => !prev);
        onSelect?.(id);
        onOpen?.(id);
    };
    if (!active)
        return null;
    return (_jsxs("group", { position: new THREE.Vector3(...position), rotation: new THREE.Euler(...rotation), children: [_jsxs("mesh", { ref: meshRef, onClick: handleClick, onPointerOver: (e) => {
                    e.stopPropagation();
                    setHovered(true);
                    document.body.style.cursor = 'pointer';
                }, onPointerOut: (e) => {
                    e.stopPropagation();
                    setHovered(false);
                    document.body.style.cursor = 'auto';
                }, children: [_jsx("planeGeometry", { args: [width / 2, height / 2] }), _jsx("meshBasicMaterial", { color: colorObj, transparent: true, opacity: 0.05, side: THREE.DoubleSide, depthWrite: false })] }), _jsx("lineSegments", { geometry: edgesGeometry, children: _jsx("lineBasicMaterial", { color: colorObj, transparent: true, opacity: hovered ? 1 : 0.5 }) }), _jsx(DiagonalLines, { width: width, height: height, color: colorObj, hovered: hovered }), _jsx(Html, { center: true, style: { pointerEvents: 'none' }, zIndexRange: [1, 0], children: _jsx("div", { style: {
                        width: 28,
                        height: 28,
                        borderRadius: '50%',
                        background: color,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: '#fff',
                        fontSize: 20,
                        fontWeight: 300,
                        boxShadow: `0 2px 12px ${color}88`,
                        opacity: hovered ? 1 : 0.6,
                        transition: 'opacity 0.2s, transform 0.2s',
                        transform: hovered ? 'scale(1.2)' : 'scale(1)',
                        userSelect: 'none',
                    }, children: "+" }) })] }));
};
const DiagonalLines = ({ width, height, color, hovered }) => {
    const geometry = useMemo(() => {
        const hw = width / 2;
        const hh = height / 2;
        const points = [
            new THREE.Vector3(-hw, -hh, 0),
            new THREE.Vector3(hw, hh, 0),
            new THREE.Vector3(hw, -hh, 0),
            new THREE.Vector3(-hw, hh, 0),
        ];
        return new THREE.BufferGeometry().setFromPoints(points);
    }, [width, height]);
    return (_jsx("lineSegments", { geometry: geometry, children: _jsx("lineBasicMaterial", { color: color, transparent: true, opacity: hovered ? 0.4 : 0.15 }) }));
};
